
// Make upload button on click trigger file form upload
$('[uploadFalseInput]').on('click', function()
{   console.log('ccdev', '105');
    var id = $(this).attr('uploadFalseInput');
    console.log('ccdev', '107', id);
    $(`#${id}`).click();
});
$('[formUploadButton]').on('click', function()
{   console.log('ccdev', '111');
    var id = $(this).attr('formUploadButton');
    console.log('ccdev', '113', id);
    $(`#${id}`).click();
});

$('[selectedFile]').on('change', function () {
	var id=$(this).attr('id');
	var files = $(this).prop("files")
	console.log('ccdev','val 018', files);
  
	//var a=$(this).val().toString().split('\\');
	var a = $.map(files, function (val) { return val.name; }).join(", ");
	//var a = names.join(', ');
	$(`[uploadFalseInput=${id}]`).val(a); //a[a.length -1]);
  });
  